import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\app\\(root)\\clientPage.jsx");
